export default {
    ROWS_LIMIT: 10,
    PAGINATION_BUTTONS_LIMIT: 5
};
